import React from 'react';
import { CalendarOff } from 'lucide-react';

interface CalendarGapCellProps {
  count: number;
  cellWidth: number;
  topMargin: number;
}

const CalendarGapCell: React.FC<CalendarGapCellProps> = ({
  count,
  cellWidth,
  topMargin,
}) => {
  return (
    <div
      className="border-r last:border-r-0 border-medihub-midPurple/20 min-h-[180px] relative font-sans bg-medihub-softBg/60"
      style={{
        width: `${cellWidth}px`,
        minWidth: `${cellWidth}px`,
        maxWidth: `${cellWidth}px`,
      }}
    >
      <div
        className="flex flex-col items-center justify-center text-medihub-secondary/50 px-3 text-center"
        style={{
          marginTop: `${topMargin}px`,
          minHeight: `${180 - topMargin}px`,
        }}
      >
        <CalendarOff className="h-6 w-6 mb-2 opacity-40" />
        <div className="text-sm font-medium">
          {count} nap rendezvény nélkül
        </div>
      </div>
    </div>
  );
};

export default CalendarGapCell;
